import { airplaneState } from '../airplane/state.js';

let boostContainer, boostFill, boostLabel;

export function initBoostUI() {
    boostContainer = document.getElementById('boost-container');
    boostFill = document.getElementById('boost-progress-fill');
    boostLabel = boostContainer ? boostContainer.querySelector('.boost-label') : null;
}

export function updateBoostUI() {
    if (!boostContainer || !boostFill) return;

    const isCharging = airplaneState.boostCharge > 0 && !airplaneState.isBoosting;
    const isBoosting = airplaneState.isBoosting;

    // Visibility toggle
    if (isCharging || isBoosting) {
        boostContainer.classList.add('visible');
    } else {
        boostContainer.classList.remove('visible');
    }

    // Active state (green pulse)
    if (isBoosting) {
        boostContainer.classList.add('active');
        if (boostLabel) boostLabel.textContent = 'BOOST ACTIVE';

        // During boost, show time remaining as progress bar decaying
        const percent = (airplaneState.boostTimeRemaining / 3.0) * 100;
        boostFill.style.width = `${percent}%`;
    } else {
        boostContainer.classList.remove('active');
        if (boostLabel) boostLabel.textContent = 'CHARGING BOOST';

        // During charging, show charge progress
        const percent = airplaneState.boostCharge * 100;
        boostFill.style.width = `${percent}%`;
    }
}
